import GraphApi from '../../api/Graphs'

export default {
  beforeDestroy() {
    if (GraphApi.Cancel !== null) {
      GraphApi.Cancel();
      GraphApi.Cancel = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GraphRequestAborter/index.js